<app-banner [heading]="'RULES'" [detail]="'Everyday is a celebration at Tagore Global School - Kurukshetra.'"></app-banner>

<section id="features" class="features">
    <div class="container">

      <div class="row feature-item">
        <!--<div class="col-lg-4">
          <img src="assets/img/about/schoolbuilding1.jpg" class="img-fluid" alt="">
        </div>-->
        <div class="col-lg-8 pt-5 pt-lg-0">
          <h4>A WORD FOR THE PARENT</h4>
          <p>
            Parents are requested to go through their ward's dairy regularly and ensure action accordingly. 
            They will also ensure that remarks made in the diary by teacher are seen and 
            counter-signed by them without fail. 
          </p>
          <p>They should help their wards to improve their handwriting and maintain their books and 
          note books properly.</p>
          <p>A student with 100% attendance will be given an award at the end of the academic session. </p>
          <p>Parents should not walk into the classroom or attempt to meet the teacher when
          class is in progress. They may contact the reception for an appointment.  </p>
          <p>Since the school has English as the medium of instruction, the 
          students should be encouraged to converse in English at home.</p>
          <p>It is advisable not to take your ward home during school hours except in extreme exigencies.</p>			
        </div>
        <div class="col-lg-8 pt-5 pt-lg-0">
          <h4>EXPECTATIONS FROM PARENTS/GUARDIANS</h4>
          <p>
            The School Executive expects that you will
          </p>
          
          <ol>
              <li>
              Be familiar with the school's expectations of pupils and backup those expectations with your 
              children.              
              </li>
              <li>
              Be available if it is necessary, to discuss aspects of your child's behaviour at school.
              </li>
              <li>
              Exercise your right as a parent and bring to the notice of the Principal, concerns and 
              suggestions to make school a happy and safe environment for your child. Confidentiality 
              will be respected.
              </li>
              <li>
              Sign circulars, progress reports or other similar documents when requested to do so as not to
              put your child to any inconvenience.
              </li>
              <li>
              Check the School Diary daily, as it forms a link between the school authorities and the parents.
              </li>
              <li>
              Offer support to school activities, and BE PRESENT to support
              and motivate your child on sports' day/ parents' day etc..
              </li>
              <li>
              Support the work of the school particularly by enforcing regularity and discipline, and by evincing interest in your child's progress and by extending the fullest co-operation to
              participation in school activities.
              </li>
              <li>
              Inculcate respect for person, property and the environment in your children.
              </li>
              <li>
               Ensure that your child is not absent on the first or last day of the school term without prior permission and that any leave taken from school is duly sanctioned.
              </li>
          </ol>
          
        </div>
        <div class="col-lg-8 pt-5 pt-lg-0">
          <h4>The Teaching Staff expects that you will:</h4>
          <ol>
              <li>
              If you wish to discuss a matter of concern to you or your child,feel free to contact an individual teacher during his/her non-teaching periods by taking prior permission from the Principal             
              </li>
              <li>
              Be open to listening and considering the teacher's opinion regarding your child, even when the comments may  be less than complimentary.
              </li>
              <li>
              Be supportive of their action in dealing with your child. Avoid undermining them in the eyes of your children by making generalised scathing comments about individual teachers or of the teaching professions in general.
              </li>
              <li>
              Find ways of letting teachers or the school know when you are particularly pleased with your child's progress or activities.
              </li>
              <li>
              Please intimate about your child's absence if known before-hand.
              </li>
              
          </ol>
          
        </div>
        <div class="col-lg-8 pt-5 pt-lg-0">
          <h4>Your children expect that you will</h4>
          <ol>
              <li>
              Be open to hearing their opinion about school situations, even when they may differ from teacher's perceptions.
              </li>
              <li>
              Intercede for them at appropriate school levels in cases when you judge they have been treated unfairly.
              </li>
              <li>
              Avoid over-reacting to instances when the school has made contact regarding some  less than satisfactory aspect of their behaviour.
              </li>
              
              
          </ol>
          
        </div>
         <div class="col-lg-8 pt-5 pt-lg-0">
          <h4>Other Parents expect that you will</h4>
          <ol>
              <li>
              Exert firm parental discipline in cases where your child's behaviour is distracting for the quality of learning opportunities for others in the school.
              </li>
              <li>
              Keep your child at home if he is suffering from contagious diseases/symptoms like  covid,mumps, measles, chicken pox, small pox,whooping cough, conjunctivitis (sore eyes) and send him to
              school only with a doctor's fitness certificate.
              </li>
          </ol>
          
          <p>The following period of isolation is recommended:-</p>
          <ul>
              <li> Covid 14 days after the first appearance of symptoms       
              <strong>Measles</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5 days after the rash disappears.
              </li>
              <li>
              <strong>Mumps</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1 week after the swelling goes down.
              </li>
              <li><strong>Chicken Pox &amp; Small Pox</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Till all the blisters dry and fall off.</li>
              <li><strong>Conjunctivitis</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Till no white discharge comes out of the eyes.</li>
          </ul>
          
        </div>
        <div class="col-lg-8 pt-5 pt-lg-0">
          <h4>CODE OF CONDUCT FOR STUDENTS </h4>
          <p>
            The School Community expects that you will 
          </p>
          
          <ol>
              <li>
              Wear the school uniform correctly and with pride.          
              </li>
              <li>
              Take advantage of every opportunity to learn. 
              </li>
              <li>
              Not take part in unacceptable behavior such as swearing, abusive language, spitting, fighting, littering, damaging school property. 
              </li>
              <li>
              Show pride in your school and present a good image especially by behaving yourself when in public and particularly on your way to and from school.
              </li>
              <li>
              Speak positively of your school and your teachers. 
              </li>
              <li>
              Co-operate with all staff members. 
              </li>
              <li>
              Show school spirit by participating in school activities. 
              </li>
              <li>
              Read circulars or listen to messages and do as instructed. 
              </li>
              <li>Move quickly and quietly from class to class avoiding unnecessary disturbances. </li>
              <li>Be on time for all classes. </li>
              <li>Bring correct text books for all periods. </li>
              <li>Stay in your place during class. </li>
              <li>Be present in class for all lessons.</li>
              <li>Not leave the school without the written permission of parents and Principal. Tuitions are discouraged as it is psychologically damaging for a child</li>
              <li>MAKE FULL USE OF THE LIBRARY and maintain silence in the library at all times. </li>
              <li>Keep off verandahs, stairs and out of class-rooms before school and during recess and lunch breaks. </li>
              <li>Keep your class room, school &amp; environment clean and tidy. </li>
              <li>Be familiar with campus and traffic rules as outlined.</li>
              <li>Make the necessary arrangement to stay back after school hours to participate in academic, sports and co-curricular activities whenever required. </li>
              <li>Respect school property and report immediately any damage to school property. </li>
              <li>Not introduce objectionable books, magazines or periodicals to the school, I-pods, video games, mobile phones, pagers and other electronics are prohibited. </li>
              <li>Not meet any visitors in school without the written permission of parents and Principal. </li>
              <li>Not drive motorized vehicles inside the school compound at any time, nor drive cars, scooters, mopeds etc. While coming to or returning from school, unless you have a license. </li>
              <li>Keep your cycle only in the cycle parking area-Locked. </li>
              <li>Not use unfair means during tests/exams. Such improper conduct is unworthy of T.G.S. students and can lead to severe penalties.</li>
              
          </ol>
          
        </div>
        <div class="col-lg-8 pt-5 pt-lg-0">
          <h4>Your Teachers expect that you will- </h4>
         <ol>
              <li>
              Show them courtesy and respect at all times.  
              </li>
              <li>
              Accept their authority, and their right to give instructions, and to allocate suitable correction to those who break rules. 
              </li>
              <li>
              Come to class on time and bring all necessary material with you. 
              </li>
              <li>
              Complete set work carefully and on time. 
              </li>
              <li>
              Listen attentively when teachers or other students are speaking. Indicate your desire to contribute by raising your hand. 
              </li>
              <li>
              Avoid any distracting behavior during lessons. 
              </li>
              <li>
              Stay in your place and do not pack up at the end of the Lesson until directed by your teacher. 
              </li>
              <li>
              Put your hand up to ask/answer question : do not call out in class. 
              </li>
              
          </ol>
          
        </div>
        <div class="col-lg-8 pt-5 pt-lg-0">
          <h4>The Members of the School community especially fellow students expect that you will </h4>
         <ol>
              <li>
              Not interfere with their person by bullying violence. 
              </li>
              <li>
              Not distort their  name by insults or spreading rumours. 
              </li>
              <li>
              Not interfere with their chances to learn by disrupting the class room environment. 
              </li>
              <li>
              Not take and spoil material belonging to others. Speak to them with courtesy and respect. 
              </li>
              <li>
              Be responsible for your actions and accept their consequences.
              </li>
          </ol>
        </div>
        
        <div class="col-lg-8 pt-5 pt-lg-0">
          <h4>LEAVE OF ABSENCE AND FINES  </h4>
         <ol>
              <li>
              Parents should avoid asking for leave for their wards as it affects their academic process. 
              </li>
              <li>
              Leave of absence is granted only on written application duly signed by the parents alongwith an undertaking that the coverage of the syllabus during leave period will be their own responsibility. 
              </li>
              <li>
              Unless the application is submitted within three days of recovery, the student will be awarded zero marks in the tests that have been missed. 
              </li>
              <li>
              Application for leave on medical grounds must be accompanied by a Medical Certificate from a qualified MBBS doctor.  
              </li>
              
          </ol>
        </div>
         <div class="col-lg-6 pt-5 pt-lg-0">
          <h4>TRANSFER CERTIFICATE/WITHDRAWAL  </h4>
              <p>Parents who wish to withdraw their ward should apply on the prescribed application for issue of the TC, 
              which is available with the receptionist on all working days. Forms must be handed over to school office duly
              filled, 30 days prior to the date on which TC is required or else tuition fee for the following month will be charged.
              <br><br>Those going abroad after the annual exam must apply for the TC by 15 Feb. </p>
              <p>In case a parent desires to withdraw a student prior to declaration of result, self-addressed envelope with registered postage should be submitted in the school office.</p>
        </div>
        <div class="col-lg-6 pt-5 pt-lg-0">
          <h4>LIBRARY RULES </h4>
              <ol>
                  <li>Only one book will be issued at a time. Failure to return the book in time will be fined. </li>
                  <li>Writing, marking or underlining library books is absolutely forbidden. </li>
                  <li>Books lost, damaged or wrongly handled, will have to be paid for or replaced </li>
                  <li>No books from the "Reference Section" will be issued. </li>
              </ol>
        </div>
        <div class="col-lg-6 pt-5 pt-lg-0">
          <h4>ATTENDANCE  </h4>
              <p>95% of attendance is required by a student to appear for any examination held by the school. Absence from the school must be given in writing to the school and signed by the parents/guardians. </p>
              <p>If student absents continuously for 15 days without any information, will be considered as drop out, and his/her name will be struck off from the roll. Re- admission can be granted if seats are available after paying the full dues. </p>
        </div>
        <div class="col-lg-6 pt-5 pt-lg-0">
          <h4>DISMISSAL/SUSPENSION </h4>
              <p>The Principal reserves the right to expel a student from the school or suspend him/her for a certain period if the conduct of the student in Principal's opinion is against the good moral tone of the school. The nature of the punishment will be based on the gravity of offence committed by the student. </p>
              <p>It is not obligatory on the Principal to give any reason for taking action against a student except that he is convinced of taking such action of dismissal/suspension.</p>
        </div>
         <div class="col-lg-6 pt-5 pt-lg-0">
          <h4>PROGRESS REPORT  </h4>
              <p>A report of the performance of a student during the term is communicated to his parents at the end of every term through progress reports. These reports contain the performance of the student in academics plus remarks from the Class Teacher and Principal. The Progress Report also reflects personality traits, achievement in co- curricular activities and health standards attained. </p>
              <p>Student's progress report duly signed by the parents must be returned within 3 days of receipt. Rs.50/- shall be charged in case of loss/damage/not submitted in time. </p>
        </div>
         <div class="col-lg-6 pt-5 pt-lg-0">
          <h4>EXCURSIONS  </h4>
              <p>The school has an Adventure Club, which organises activities like cycling (long distance), Trekking, Skiing, Rock Climbing, Desert walking etc.  </p>
              <p>The club also organises activities. For these activities Bronze, Silver and Gold Medals are awarded after attaining required standard in the chosen activity.
              <br><br><strong>Trips are normally organised during vacations. </strong>
              </p>
        </div>
         <div class="col-lg-12 pt-5 pt-lg-0">
          <h4>EXERCISE-BOOKS INSPECTION </h4>
              <p>Exercise Book of students shall be inspected regularly by the school administration. Student must submit their exercise books on the specified day every week according to the given schedule, failing which fine of Rs. 10/ per day shall be imposed.</p>
              
          
        
        
        
        
        
      </div>
    </div>
  </div></section>